import axios from 'axios';
import { HttpService, SUCCESS_STATUS_CODE } from '@superdata/basic-data-service';
import LoginService from '../login';
import { ForceServiceParams, LogoutServiceParams, ForceLoginFields, Result, STATUS, UserInfo } from '../types';

interface AuthServiceProps {
  forceLoginProps?: ForceServiceParams;
  logoutProps: LogoutServiceParams;
  AccountService?: LoginService;
  MobileService?: LoginService;
  ThirdPartyService?: LoginService;
  PKIService?: LoginService;
  alias: string;
  formatter: (e: any) => UserInfo;
}

export default class AuthService {
  constructor(props: AuthServiceProps) {
    this.alias = props.alias;
    this.formatter = props.formatter;
    Object.assign(this, props);
  }

  alias: string;
  formatter: (e: any) => UserInfo;

  AccountService?: LoginService;
  MobileService?: LoginService;
  ThirdPartyService?: LoginService;
  PKIService?: LoginService;
  forceLoginProps?: ForceServiceParams;
  logoutProps!: LogoutServiceParams;

  afterSuccess(data: any) {
    // TODO: 用户数据暂时保存在localStorage
    // 用户数据灵活处置
    localStorage.setItem('user', JSON.stringify(this.formatter(data[this.alias])));
    localStorage.setItem('token', data?.token);
    return { status: STATUS.SUCCESS };
  }

  async forceLogin(params: ForceLoginFields) {
    if (this.forceLoginProps) {
      const { url, fields } = this.forceLoginProps;
      const payload: any = Object.keys(fields).map((key) => {
        return `${fields[key]}=${params[key]}`;
      });
      const data =
        await axios.post(
          `${url}?${payload.join('&')}`,
          undefined, { headers: { Authorization: params.token } }
        ).then((data) => data.data);
      if (data.code === SUCCESS_STATUS_CODE) {
        return this.afterSuccess(data?.data);
      }
      return { status: STATUS.FAILED, message: data.message, code: data.code };
    }
  }
  logout() {
    const { url } = this.logoutProps;
    HttpService.post(url).then(() => {
      localStorage.removeItem('dicts');
      localStorage.removeItem('permission');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    });
  }
}

export type { Result };